// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"90fc0b2e57ab3f8a2023","488":"7d5f672b006c0e4dc423","532":"7ea257594c81849b51b2","592":"e32cf6173d687c89372a","736":"07f2c4f2c89443bfde3b"}[chunkId] + ".js";
};